import Layout from '@/components/v2/Layout';
import MemberProfileUpdate from '@/components/v2/MemberProfileUpdate';

const MemberProfile = () => {
  return (
    <Layout>
      <MemberProfileUpdate />
    </Layout>
  );
};

export default MemberProfile;
